import { connect } from 'react-redux';

import {
	selectConversationsByLastUpdate,
	selectConversationsCurrent,
} from '../../selectors';

import { setCurrentConversation } from '../../actions';

import List from './list';


export default connect((state) => {
 return {
 	currentConversationId: selectConversationsCurrent(state),
 	conversations: selectConversationsByLastUpdate(state),
 };
}, (dispatch) => ({
	onOpenConversation: (id) => {
		dispatch(setCurrentConversation(id));
	},
}))(List);



// WEBPACK FOOTER //
// ./src/modules/conversations/components/list/connector.js